export default "__VITE_ASSET__5fa4f3e1__"